import React, { FC } from 'react';

const HazardEnvironment: FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 170 170"
    {...props}
  >
    <g clipPath="url(#HazardEnvironment_1)">
      <path
        fill="#EB1F26"
        d="M6.415 85.48 85.196 9.255 163.98 85.48l-78.783 76.224L6.415 85.479Z"
      />
      <mask
        id="HazardEnvironment_2"
        width={162}
        height={156}
        x={4}
        y={7}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path fill="#fff" d="M4.54 162.015h161.298V7.45H4.541v154.565Z" />
      </mask>
      <g mask="url(#HazardEnvironment_2)">
        <path
          stroke="#ED1C24"
          strokeWidth={0.918}
          d="m163.979 85.48-78.782 76.224L6.416 85.479l78.78-76.222 78.783 76.222Z"
        />
      </g>
      <path
        fill="#fff"
        d="m19.024 85.485 66.173-64.022 66.172 64.022-66.174 64.024-66.17-64.024Z"
      />
      <mask
        id="HazardEnvironment_3"
        width={162}
        height={156}
        x={4}
        y={7}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path fill="#fff" d="M4.54 162.015h161.298V7.45H4.541v154.565Z" />
      </mask>
      <g fill="#231F20" mask="url(#HazardEnvironment_3)">
        <path d="M89.709 94.745c1.938-.418 4.757-2.26 5.626-4.102.378-.8 2.332-4.9 3.776-7.18 2.083-3.29 4.285-6.15 10.173-7.849.724-.21 2.156-.454 3.747-.597l-1.364 3.914 1.765-.322 5.512-1.023c-.023.784-.118 1.848-.431 2.866-.564 1.834-3.282 5.216-4.06 5.78-1.138.826-5.094 3.386-5.742 3.615-.412.148-2.54.74-4.417 1.265-2.353.655-3.811 1.062-4.183 1.198l-.711.171c-.779.163-1.846.385-2.732 1.05l-.358.248c-.697.463-1.233.89-1.79 2.174 0 0-.922 2.118-1.619 3.714a3.942 3.942 0 0 0-.446-.494c-.638-.565-4.193-2.902-5.312-3.394l-.534-.226a48.222 48.222 0 0 1 3.1-.808Zm-6.427-5.37c-.386-.312-2.447-1.31-2.576-1.745-.025-.081-.048-.585-.07-1.357h14.527a122.007 122.007 0 0 0-1.739 3.525c-.5 1.058-2.256 2.295-3.6 2.791-.343-.084-.815-.2-1.39-.348-1.224-.312-4.766-2.556-5.152-2.866Zm33.588 12.493c-.154-.449 2.016-.6 2.016-1.95s-1.705-1.5-4.029-1.35c-2.326.15-4.03.3-4.805.3-.775 0-1.395-.45-.465-.748.93-.3 6.509-1.051 6.819-2.7.21-1.116-2.422-3.33-5.153-4.646a94.105 94.105 0 0 0 4.46-2.916c.376-.272.944-.85 1.563-1.585h3.934v-5.248h-.681c.692-2.255.509-4.645.499-4.745l-.091-1.133-6.131 1.138 1.211-3.476-1.531.075c-2.352.094-4.7.464-5.803.784-5.724 1.65-8.395 4.367-10.458 7.357H80.538c-.04-3.271-.057-6.572-.025-6.792.065-.435 1.223-1.433 1.996-2.243.773-.81 3.285-3.489 3.8-3.74.516-.248 2.253-.685 2.705-.808.451-.124 1.546-.062 2.254-.437.708-.374 2.64-3.053 3.35-3.925.708-.873 2.77-4.361 2.896-4.736.13-.373-.579-.934-.773-.872-.192.062-.45.623-.773 1.121-.321.499-4.377 4.736-4.957 5.235-.58.498-.967.871-1.48.997-.517.124-4.317.374-5.024.435-.71.063-1.29.686-1.74 1.247-.45.56-1.803 1.932-1.996 1.744-.193-.187 0-.437.064-.747.064-.312 1.289-2.493 1.868-3.925.58-1.434.515-2.431.58-2.93.064-.498-.323-2.927-.323-3.239 0-.312.322-.685.837-1.246.516-.562 2.834-2.618 3.671-3.739.837-1.12 2.576-3.925 2.77-4.549.192-.623.45-1.12.322-1.37-.13-.25-.837-.375-1.03-.375-.193 0-.386.437-.645 1.184-.257.748-1.739 2.929-2.32 3.74-.578.81-3.155 3.301-3.54 3.613-.387.312-.71.935-.774.56-.064-.373-.323-3.301-.386-3.987-.064-.685-.644-5.607-.708-5.857-.065-.249-1.803-.063-1.803.25 0 .311.579 5.295.773 7.975.192 2.678.514 6.73.192 7.914-.322 1.183-3.478 5.545-3.736 5.857-.258.31-.9.062-1.094-.188-.194-.25-1.48-5.17-2.06-6.854-.581-1.683-1.739-8.849-1.739-8.849s.708-3.176.901-4.173c.193-.998-.063-2.617-.063-2.617l-1.032.312s-.258 1.806-.45 2.554c-.194.748-.838 2.679-.838 2.679s-1.03-2.74-2.254-4.3c-1.223-1.558-3.284-3.363-3.284-3.363l-.838.871s1.482 1.682 2.448 2.929c.966 1.245 1.997 3.427 2.254 5.42.258 1.994.516 5.733.516 5.733s-1.868-.623-2.447-.934c-.58-.312-2.705-2.244-3.866-3.116-1.158-.872-2.96-1.62-2.96-1.62l-.646.997s1.288.81 2.191 1.37c.902.561 3.862 3.303 4.701 4.05.837.749 2.318 1.746 3.414 3.304 1.095 1.557 1.094 3.178 1.287 3.862.193.686.193 1.06.063 1.309-.128.25-.386 0-.836-.125-.45-.124-2.769-1.62-3.477-2.055-.71-.437-1.61-.997-4.766-.874-3.156.126-3.929 1.372-3.929 1.372l1.159 1.246s1.29-.81 3.286-.81c1.995 0 5.087 1.931 6.696 3.364 1.61 1.434 2.576 2.867 2.576 4.113 0 .57.014 4.207.004 8.038H55.344v5.248h16.123c-.028 2.434-.08 4.267-.163 4.41-.258.436-2.318 1.868-3.157 2.242-.836.374-5.28 1.87-5.473 1.933-.193.063-.644.186-.45.249.193.063 2.06.063 2.703.063.645 0 1.676.061 2.513-.187.837-.25 3.09-.81 5.216-.686 2.126.125 2.512 1.62 2.835 2.18.32.562.706 1.31.706 1.31s.71-1.745 1.095-2.556c.388-.809 1.804-2.865 2.448-3.24.644-.373 2.384-.249 2.963-.124.58.124 2.06.31 2.705.562.643.248 1.802.31 2.512.435.188.033.456.039.745.032-1.73.41-4.448 1.192-5.385 1.647l-2.003.971 3.25 1.375c-3.461 1.804-13.114 6.329-14.614 6.329-1.705 0-2.17-.901-2.946-.751-.774.15-13.638 3.899-13.638 3.899h68.346v-3.899s-4.651-.15-4.805-.599Z" />
        <path
          fillRule="evenodd"
          d="M117.856 81.054c0 .79-.662 1.43-1.479 1.43-.817 0-1.479-.64-1.479-1.43 0-.79.662-1.43 1.479-1.43.817 0 1.479.64 1.479 1.43Z"
          clipRule="evenodd"
        />
      </g>
    </g>
    <defs>
      <clipPath id="HazardEnvironment_1">
        <path fill="#fff" d="M0 0h170v170H0z" />
      </clipPath>
    </defs>
  </svg>
)

export default HazardEnvironment;
